var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIllustrations.js
import * as React from 'react';
import IllustrationContainer from '../IllustrationContainer.js';

function PieGraphIllustration(props) {
  return /*#__PURE__*/React.createElement(IllustrationContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M117.242 34.181L89.588 48.648c2.657 4.527 4.231 9.742 4.231 15.352 0 10.629-5.61 19.978-13.974 25.292C75.219 92.146 69.807 93.82 64 93.82c-16.041 0-29.13-12.597-29.819-28.441V64c0-16.435 13.384-29.819 29.82-29.819V2.984C30.342 2.984 2.983 30.343 2.983 64c0 1.575.099 3.15.197 4.724 2.362 31.492 28.737 56.292 60.82 56.292 11.513 0 22.339-3.248 31.59-8.759C113.207 105.53 125.016 86.143 125.016 64a60.895 60.895 0 00-7.774-29.819z",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M117.241 34.181L89.587 48.648C84.371 39.988 74.825 34.18 64 34.18V2.984c22.832 0 42.81 12.597 53.241 31.197z",
      fill: "#009CEB",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M62.672 79h2.656v-3.058C70.31 75.48 73 72.636 73 68.69c0-5.262-3.852-6.862-7.672-7.573v-8.143c2.325.391 3.321 1.743 3.554 3.094h3.288c-.3-2.916-2.524-5.511-6.842-5.974V47h-2.656v3.093c-4.816.427-7.174 3.271-7.174 6.685 0 4.622 3.52 6.329 7.174 7.146v9.138c-2.99-.355-4.251-1.884-4.384-3.662H55c.299 3.307 2.657 6.116 7.672 6.542V79zm7.073-10.133c0 2.204-1.394 3.84-4.417 4.195v-8.64c2.89.676 4.417 1.6 4.417 4.445zM58.753 56.6c0-1.564.996-3.236 3.919-3.662v7.609c-2.59-.676-3.92-1.707-3.92-3.947z",
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M2.984 68.822l.197-.098 31-3.346M95.59 116.257L79.846 89.292",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })))
  }));
}

export default PieGraphIllustration;